import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const copyFulfillmentGroupViews = unaryRpc({
  name: "copyFulfillmentGroupViews",
  input: z.object({
    sourceTeamId: zExt.objectId(),
    destinationTeamId: zExt.objectId(),
  }),
  output: z.object({
    success: z.boolean(),
    message: z.string().optional(),
    deletedViewCount: z.number().optional(),
    copiedViewCount: z.number().optional(),
  }),
});
